import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { components, contentfulModels } from '@glowforge/ui-common';
import { pendingInvitesPropTypes, machinePropType } from 'app/selectors/machines';
import Invites from './invites';
import Users from './users';

import './users-and-invites.less';

const { pageStringsPropType } = contentfulModels;
const { Button } = components;

const TABS = {
  USERS: 1,
  INVITES: 2,
};

class UsersAndInvites extends Component {
  constructor(props) {
    super(props);
    this.state = { viewedTab: TABS.USERS };
  }

  showInvites = () => {
    this.setState({ viewedTab: TABS.INVITES });
  };

  showUsers = () => {
    this.setState({ viewedTab: TABS.USERS });
  };

  render() {
    let table = <Users {...this.props} />;
    let tabs;
    if (!_.isEmpty(this.props.pendingInvites)) {
      if (this.state.viewedTab === TABS.INVITES) {
        table = <Invites {...this.props} />;
      }

      tabs = (
        <div className='tabs'>
          <button
            className={`clearButton ${this.state.viewedTab === TABS.USERS ? 'selected' : ''}`}
            onClick={this.showUsers}>
            {this.props.pageStrings['settings-users-tab-name']}
          </button>
          <button
            className={`clearButton ${this.state.viewedTab === TABS.INVITES ? 'selected' : ''}`}
            onClick={this.showInvites}>
            {this.props.pageStrings['settings-tab-pending-invites']} ({this.props.pendingInvites.length})
          </button>
        </div>
      );
    }

    let inviteButton;
    if (!_.isEmpty(this.props.managedMachines)) {
      inviteButton = (
        <Button onClick={this.props.gotoInviteForm}>
          {this.props.pageStrings['add-user-button']}
        </Button>
      );
    }

    return (
      <div className='UsersAndInvites'>
        <h1 className='h2'>
          {this.props.pageStrings['settings-users-tab-name']}
          {inviteButton}
        </h1>
        {tabs}
        {table}
      </div>
    );
  }
}

UsersAndInvites.propTypes = {
  gotoInviteForm: PropTypes.func.isRequired,
  pendingInvites: PropTypes.arrayOf(PropTypes.shape(pendingInvitesPropTypes)),
  machines: PropTypes.arrayOf(PropTypes.shape(machinePropType)),
  managedMachines: PropTypes.arrayOf(PropTypes.shape(machinePropType)),
  pageStrings: pageStringsPropType.isRequired,
};

UsersAndInvites.defaultProps = {
  pendingInvites: [],
  machines: [],
  managedMachines: [],
};

export default UsersAndInvites;



// WEBPACK FOOTER //
// ./app/components/settings/users-and-invites.jsx